import type PersonaType from 'owa-service/lib/contract/PersonaType';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import searchCache from '../selectors/searchCache';
import { action } from 'satcheljs/lib/legacy';
import type { CachePersona } from '../store/schema/RecipientCacheStore';
import { isFeatureEnabled } from 'owa-feature-flags';

const NUM_SUGGESTED_CONTACTS = 5;

export default action('getAndPopulateSuggestedContacts')(function getAndPopulateSuggestedContacts(
    resultsToPopulate: PersonaType[],
    wellContents?: { EmailAddress: EmailAddressWrapper }[]
) {
    let personaTypeSet: PersonaType[];
    if (isFeatureEnabled('rp-enableZqFvlJoin')) {
        let rcTopFive = searchCache(
            '' /* searchQuery */,
            NUM_SUGGESTED_CONTACTS,
            wellContents
        ) as CachePersona[];

        personaTypeSet = rcTopFive.map(result => {
            return {
                EmailAddress: result.EmailAddress,
                PersonaId: result.PersonaId,
                ADObjectId: result.ADObjectId,
                ReferenceId: result.ReferenceId,
            };
        });
    } else {
        let rcTopFive = searchCache('' /* searchQuery */, NUM_SUGGESTED_CONTACTS, wellContents);

        personaTypeSet = rcTopFive.map(result => {
            return {
                EmailAddress: result.EmailAddress,
                PersonaId: result.PersonaId,
                ADObjectId: result.ADObjectId,
            };
        });
    }

    resultsToPopulate.splice(0, resultsToPopulate.length, ...personaTypeSet);
});
